import React from 'react';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import Fs3ChartsBoxContent from 'ui-elements/boxes/Fs3BarChartsBoxContent';
import reportLocales from 'globals/locales/report';
import { green, red, yellow } from 'globals/colors';
import { useReportContext } from 'contexts/report/ReportContext';
import { isSuccessState } from 'globals/utils';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { observer } from 'mobx-react';
import { Fade } from '@material-ui/core';
import { getTooltipContent } from 'ui-elements/modals/FsDefaultDialog/FsDefaultDialog.utils';
import { tooltipContent } from './IncomeStability.utils';

// Locales
const { title } = reportLocales.incomeStability;
const colorArray = [yellow.MAIN, red.MAIN, green.MAIN];

const IncomeStability: React.FC = () => {
  const {
    report: {
      incomeStability: { status, graphsValues, infoBoxes },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper
        title={title}
        tooltipContent={getTooltipContent(tooltipContent)}
        data-test="income-stability-component"
      >
        <Fs3ChartsBoxContent
          graphs={graphsValues()}
          infoBoxItems={infoBoxes}
          colorArray={colorArray}
        />
      </FsPaper>
    </Fade>
  );
};

IncomeStability.displayName = 'IncomeStability';

export default observer(IncomeStability);
